import moment from "moment";
import { toast } from "react-toastify";

export const getProperty = <T, K extends keyof T>(obj: T, key: K) => {
  return obj[key];
};

export const pxToNumber = (value: string) => {
  if (value) {
    return parseInt(value.replace("px", ""), 10);
  }

  return 0;
};

export const getHeightBeforeEndOfPage = (
  selector: string,
  defaultHeight: number,
  windowHeight: number,
  extraHeight?: number
) => {
  const element = document.querySelector(selector) as HTMLElement;
  const bottomPadding = 16;
  if (element) {
    return (
      windowHeight -
      element.getBoundingClientRect().top -
      (extraHeight ? extraHeight : 0) -
      bottomPadding
    );
  }

  return defaultHeight;
};

export const getQueryStringFromModel = (model: any) => {
  let queryString = "";
  for (const param of Object.keys(model)) {
    if (
      model[param] !== null &&
      typeof model[param] !== typeof undefined &&
      model[param] !== ""
    ) {
      if (queryString !== "") {
        queryString = `${queryString}&`;
      }
      queryString = `${queryString}${param}=${model[param]}`;
    }
  }

  return queryString;
};

export const makeId = (length: number) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

// copy to clipboard
const fallbackCopyTextToClipboard = (text: string) => {
  var textArea = document.createElement("textarea");
  textArea.value = text;  
  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    const successful = document.execCommand('copy');
    if (successful) {
      toast.info("Copied to clipboard!", { autoClose: 3000 });
    } else {
      toast.error("Failed to copy to clipboard!");
    }    
  } catch (err) {
    toast.error(err as any || "Error while copying to clipboard!");
  }
  document.body.removeChild(textArea);
}

export const copyTextToClipboard = (text: string) => {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(
  () => {
    toast.info("Copied to clipboard!", { autoClose: 3000 });
  }, () => {
    toast.error("Failed to copy to clipboard!");
  });
}
// /copy to clipboard

export const nextBusinessDay = () => {
  let nextDay = moment().add(1, "day");
  while (nextDay.day() === 0 || nextDay.day() === 6) {
    nextDay.add(1, "day");
  }
  return nextDay.format("MM/DD/YYYY");
};
